import { Icon, Modal } from '@successmode-ktp/kui';
import ICON_FILE from '@/assets/korUploadFile/icon_file.png';
import IMG_CHECK_1 from '@/assets/korUploadFile/img_check_1.png';
import IMG_CHECK_2 from '@/assets/korUploadFile/img_check_2.png';
import IMG_CHECK_3 from '@/assets/korUploadFile/img_check_3.png';
import styled from 'styled-components';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onClick: () => void;
};

const UploadCheckModal = ({ isOpen, onClick, onClose }: Props) => {
  return (
    <Modal isOpen={isOpen} hasBackdrop wrapperStyle={{ maxWidth: '340px' }}>
      <Modal.Header>
        <TitleWrapper>
          <Icon.QuestionFilled fillColor='#CBCCCE' />
          업로드 전
          <br />
          한번 더 확인해주세요
        </TitleWrapper>
      </Modal.Header>
      <ModalBody>
        <div>
          <SubtitleWrapper>
            <img src={ICON_FILE} alt='' width={24} height={24} />
            <strong>출입국사실증명서 업로드 할 경우</strong>
          </SubtitleWrapper>
          <ContentsWrapper>
            <WarningWrapper>
              <WarningText>1. 조회기간이 올바르게 설정되었나요?</WarningText>
              <img src={IMG_CHECK_1} alt='' />
            </WarningWrapper>
            <WarningWrapper>
              <WarningText>1. 최종 출국일자가 포함되어 있나요?</WarningText>
              <img src={IMG_CHECK_2} alt='' />
            </WarningWrapper>
          </ContentsWrapper>
        </div>
        <div>
          <SubtitleWrapper>
            <img src={ICON_FILE} alt='' width={24} height={24} />
            <strong>기타자료를 업로드 할 경우</strong>
          </SubtitleWrapper>
          <ContentsWrapper>
            <WarningWrapper>
              <WarningText>
                1. 입국항공권(해외 → 한국)과 출국항공권(한국 → 해외) 2가지 모두
                첨부가 되었나요?
              </WarningText>
              <img src={IMG_CHECK_3} alt='' />
            </WarningWrapper>
            <WarningWrapper>
              <WarningText>1. 해외체류증빙자료 첨부가 되었나요?</WarningText>
              <Text>
                영주권, 거주자카드(재류카드), 비자, 해외거주 사실확인서 중 1가지
              </Text>
            </WarningWrapper>
          </ContentsWrapper>
        </div>
      </ModalBody>
      <Modal.Footer>
        <Modal.Button type='button' variant='cancel' onClick={onClose}>
          다시 첨부
        </Modal.Button>
        <Modal.Button type='button' onClick={onClick}>
          업로드
        </Modal.Button>
      </Modal.Footer>
    </Modal>
  );
};
export default UploadCheckModal;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 0px auto 16px;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  padding: 16px 0;
`;

const SubtitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: var(--KTP-Grayscale-Gray_03, #333);
  font-size: 16px;
  font-weight: 600;
  line-height: 140%; /* 22.4px */
  letter-spacing: -0.32px;
`;

const ContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const WarningWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const WarningText = styled.strong`
  display: block;
  margin-bottom: 8px;
  color: var(--KTP-Warning-100, #ed0828);
  font-size: 13px;
  font-weight: 500;
  line-height: 140%; /* 18.2px */
  letter-spacing: -0.26px;
`;

const Text = styled.p`
  color: var(--KTP-Grayscale-Gray_05, #777);
  font-size: 13px;
  font-weight: 500;
  line-height: 140%; /* 18.2px */
  letter-spacing: -0.26px;
`;
